import * as actionTypes from "../actionTypes";

const initialState = {
  wastes: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_WASTES:
      return {
        ...state,
        wastes: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
